import { Component } from 'react'
import { string, oneOf } from 'prop-types'

import doesImageExist from '../../../utilities/doesImageExist.js'

import UserPlaceholder from '../../../../img/user-placeholder.jpg'
import instagram from '../../../../img/sources/instagram.svg'
import facebook from '../../../../img/sources/facebook.svg'
import twitter from '../../../../img/sources/twitter.svg'
import tiktok from '../../../../img/sources/tiktok.svg'
import rss from '../../../../img/sources/rss.svg'
import tumblr from '../../../../img/sources/tumblr.svg'
import youtube from '../../../../img/sources/youtube.svg'
import pinterest from '../../../../img/sources/pinterest.svg'
import { PLATFORMS } from '../../../utilities/constants.js'

function getPlaceholderBySource(source) {
  switch (source) {
    case PLATFORMS.INSTAGRAM: {
      return instagram
    }
    case PLATFORMS.FACEBOOK: {
      return facebook
    }
    case PLATFORMS.TWITTER: {
      return twitter
    }
    case PLATFORMS.RSS: {
      return rss
    }
    case PLATFORMS.TUMBLR: {
      return tumblr
    }
    case PLATFORMS.YOUTUBE: {
      return youtube
    }
    case PLATFORMS.PINTEREST: {
      return pinterest
    }
    case PLATFORMS.TIKTOK: {
      return tiktok
    }
    default: {
      return UserPlaceholder
    }
  }
}

function getPlaceholderAltText(source) {
  switch (source) {
    case PLATFORMS.INSTAGRAM: {
      return 'Instagram icon'
    }
    case PLATFORMS.FACEBOOK: {
      return 'Facebook icon'
    }
    case PLATFORMS.TWITTER: {
      return 'X/Twitter icon'
    }
    case PLATFORMS.RSS: {
      return 'RSS icon'
    }
    case PLATFORMS.TUMBLR: {
      return 'Tumblr icon'
    }
    case PLATFORMS.YOUTUBE: {
      return 'YouTube icon'
    }
    case PLATFORMS.PINTEREST: {
      return 'Pinterest icon'
    }
    case PLATFORMS.TIKTOK: {
      return 'TikTok icon'
    }
    default: {
      return 'Generic platform icon'
    }
  }
}

const DEFAULT_STATE = {
  altText: 'Generic platform icon',
  profileImage: '',
  cssClass: '',
}

export default class UserProfileImage extends Component {
  static propTypes = {
    className: oneOf([
      'bzfy-feed-gate-modal__profile-image',
      'bzfy-feed-gate-modal__profile-image-placeholder',
      'bzfy-o-header__image',
      'bzfy-o-profile-image',
      'bzfy-c-tilegrid-post__profile-avatar',
    ]).isRequired,
    profileImageUrl: string,
    source: oneOf(Object.values(PLATFORMS)),
  }

  static defaultProps = {
    profileImageUrl: undefined,
    source: undefined,
  }

  constructor(props) {
    super(props)
    this.state = { ...DEFAULT_STATE }
  }

  componentDidMount() {
    this.setUserProfileImage()
  }

  setUserProfileImage = async () => {
    const { className, profileImageUrl, source } = this.props
    const placeholder = getPlaceholderBySource(source)
    const placeholderCSSClass = 'bzfy-feed-gate-modal__profile-image-placeholder'

    try {
      await doesImageExist(profileImageUrl)
      this.setState({
        altText: 'Profile image for user',
        profileImage: profileImageUrl,
        cssClass: source === 'custom' ? placeholderCSSClass : className,
      })
    } catch (error) {
      this.setState({
        altText: getPlaceholderAltText(source),
        profileImage: placeholder,
        cssClass: className.includes('gate') ? placeholderCSSClass : className,
      })
    }
  }

  render() {
    return (
      <i
        aria-label={this.state.altText}
        className={this.state.cssClass}
        role="img"
        style={{ backgroundImage: `url(${this.state.profileImage})` }}
        tabIndex={-1}
      />
    )
  }
}
